import { useDraggable } from '@dnd-kit/core'
import React from 'react'
import { OrderCard } from './OrderCard'

export function DraggableOrderCard({ order, onUpdateStatus, buttonText, buttonColor, showUndo, undoText, onUndo, isPending, bounce }) {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: order.id,
  })

  const style = {
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
    touchAction: 'none',
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
      role="button"
      tabIndex={0}
      aria-label={`Order ${order.order_number}, ${order.order_items?.length || 0} items, ${order.status}`}
      aria-describedby="drag-instructions"
      className={`cursor-grab active:cursor-grabbing transition-opacity duration-150 ${isDragging ? 'opacity-0' : ''}`}
    >
      <OrderCard
        order={order}
        onUpdateStatus={onUpdateStatus}
        buttonText={buttonText}
        buttonColor={buttonColor}
        showUndo={showUndo}
        undoText={undoText}
        onUndo={onUndo}
        isPending={isPending}
        glow={bounce}
      />
    </div>
  )
}
